import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["destroyField"]

  remove() {
    // If there's a _destroy field (Rails nested attributes), mark for destruction
    if (this.hasDestroyFieldTarget) {
      this.destroyFieldTarget.value = "1"
      this.element.classList.add("hidden")
    } else {
      // Otherwise just remove from DOM (new unsaved record)
      this.element.remove()
    }
  }
}
